import { render, staticRenderFns } from "./Renewals.vue?vue&type=template&id=35eb3c7c&"
import script from "./Renewals.vue?vue&type=script&lang=js&"
export * from "./Renewals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports